export default (element) => {
  const body = document.querySelector('body');
  const openFiltersButton = element.querySelector(
    '[data-target="filter-button"]',
  );

  const closeFiltersButtons = document.querySelectorAll(
    '[data-target="close-filter-button"]',
  );

  const applyFiltersButton = document.querySelector(
    '[data-target="apply-filters"]',
  );

  const filtersPanel = document.querySelector('[data-collection-filters]');

  const filtersOverlay = document.querySelector(
    '[data-target="filters-overlay"]',
  );

  const fromSlider = document.querySelector('[data-target="from-slider"]');

  const toSlider = document.querySelector('[data-target="to-slider"]');

  const filtersContainer = document.querySelector('.filters-container');

  const filterBar = document.querySelector('.filter-bar');

  const filterBarInitialTop = filterBar.offsetTop;
  const filterBarHeight = filterBar.offsetHeight;

  const rangeMainColor = '#000';

  const init = () => {
    openFiltersButton?.addEventListener('click', openFilters);
    applyFiltersButton?.addEventListener('click', closeFilters);
    filtersOverlay?.addEventListener('click', closeFilters);

    closeFiltersButtons?.forEach((item) => {
      item.addEventListener('click', closeFilters);
    });

    window.addEventListener('scroll', () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > filterBarInitialTop) {
        if (!filterBar.classList.contains('sticky-filter')) {
          filterBar.classList.add('sticky-filter');
          filtersContainer.style.paddingBottom = `${filterBarHeight}px`;
        }
      } else if (filterBar.classList.contains('sticky-filter')) {
        filterBar.classList.remove('sticky-filter');
        filtersContainer.style.paddingBottom = 0;
      }
    });

    if (toSlider && fromSlider) {
      fillSlider(fromSlider, toSlider, 'transparent', rangeMainColor, toSlider);

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider);
    }
  };

  const fillSlider = (from, to, sliderColor, rangeColor, controlSlider) => {
    const controlSliderItem = controlSlider;
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSliderItem.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
  };

  const controlFromSlider = () => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, 'transparent', rangeMainColor, toSlider);
    if (from > to) {
      fromSlider.value = to;
    }
  };

  const controlToSlider = () => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, 'transparent', rangeMainColor, toSlider);
    toSlider.value = from <= to ? to : from;
  };

  const getParsed = (currentFrom, currentTo) => {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  };

  const openFilters = () => {
    filtersPanel.classList.add('open');
    body.classList.add('disabled-scroll');
  };

  const closeFilters = () => {
    filtersPanel.classList.remove('open');
    body.classList.remove('disabled-scroll');
  };

  init();
};
